import FormikCheckbox from 'components/formikFields/checkbox';
import FormikSelect from 'components/formikFields/select';
import TextAreaFormik from 'components/textarea';
import {
  CitiesToOption,
  ProvincesToOption,
} from 'utilities/helper/provinceToOption';
import UseGetProvince from 'utilities/hooks/province/useGetProvince';

const InfoFormComponent = ({cities, values, app}: IInfoFormComponentProps) => {
  const {provinces} = UseGetProvince();
  return (
    <>
      <p className=" text-gray-6 font-extrabold ">
        عنوان آگهی<span className=" text-error">*</span>
      </p>
      <div className="mt-3">
        <TextAreaFormik name="title" row={3} />
      </div>
      <div className="mt-4">
        <p className=" text-gray-6 font-extrabold">توضیحات</p>
        <p className=" text-gray-6">جزئیات و نکات قابل توجه مربوط به مزرعه</p>
        <div className="mt-3">
          <TextAreaFormik name="description" row={5} />
        </div>
      </div>
      <div className="mt-4">
        <p className=" text-gray-6">محدوده آگهی</p>
        <div className="mt-3">
          <FormikSelect
            name="state"
            label="استان"
            Options={ProvincesToOption(provinces || [])}
          />
        </div>
        <div className="mt-6">
          <FormikSelect
            name="city"
            label="شهر"
            Options={CitiesToOption(cities)}
            disabled={!values.state}
          />
        </div>
      </div>
      <div className="mt-6 flex">
        <FormikCheckbox
          name="hide_phone_number"
          value={
            app === 'farm'
              ? 'شماره تلفن در آگهی نمایش داده نشود.'
              : 'اجازه تماس به مشتری داده نشود.'
          }
        />
      </div>
      <div className="mt-8">
        <button
          type="submit"
          className=" w-full text-white bg-primary py-4 rounded-lg mb-6"
        >
          ادامه
        </button>
      </div>
    </>
  );
};

export default InfoFormComponent;
